import { createFileRoute } from "@tanstack/react-router"
import PurchasePlan from "~/pages/procurement/purchase-plan"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/procurement/supply-plan/")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Supply Plans")
  return <PurchasePlan />
}
